import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "CheckoutProfileEdit" })
export default class CheckoutProfileEdit extends Vue {
    public localizer: any = Localizer;
    public formHelper: any = FormHelper;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public formData: any = {};
    public profileTaxTypes: any[] = [];
    public validationErrors: any[] = [];

    @Prop() readonly returnUrl: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await this.getData();
    }

    public async getData() {
        const result = (await Axios.post(this.routes.Account_GetProfileEditData)).data;

        this.formData = JSON.parse(JSON.stringify(result.checkoutProfile));

        this.profileTaxTypes = result.profileTaxTypes;
    }

    public setProfileTaxType() {
        if (this.formData.profileTaxType === "Persona fisica") {
            this.formData.company = null;
            this.formData.ivaCode = null;
            this.formData.sdiCode = null;
            this.formData.certifiedEmail = null;
        }
    }

    public copyProfile() {
        this.formData.shippingAddress = this.formData.address;
        this.formData.shippingPostCode = this.formData.postCode;
        this.formData.shippingCity = this.formData.city;
        this.formData.shippingProvince = this.formData.province;
    }

    public copyProfilePay() {
        this.formData.payAddress = this.formData.shippingAddress;
        this.formData.payPostCode = this.formData.shippingPostCode;
        this.formData.payCity = this.formData.shippingCity;
        this.formData.payProvince = this.formData.shippingProvince;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            await Axios.post(this.routes.Account_ProfileEdit, this.formData);

            this.isSuccess = true;

            window.location.href = this.returnUrl ? this.returnUrl : "/";
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};